(function () {
	let swiperCollectionGrid;
	const collectionGridSwipeEnabled = document.querySelector(
		".swiper-container-grid",
	);

	const addClasses = () => {
		const slides = document.querySelectorAll(".collection-grid-swiper__item");
		slides.forEach((slide) => {
			slide.classList.add("swiper-slide");
		});
	};

	const initSlider = () => {
		swiperCollectionGrid = new Swiper(".swiper-container-grid", {

            speed: 1200,
			loop: false,
    		autoplay: {
                delay: 4000,
                pauseOnMouseEnter: true,
                disableOnInteraction: true,
            },
           navigation: {
				nextEl: `.swiper-button-next`,
				prevEl: `.swiper-button-prev`,
			},
		});
	};

	const destroySlider = () => {
		const slides = document.querySelectorAll(".collection-grid-swiper__item");

		if (Array.isArray(swiperCollectionGrid)) {
			swiperCollectionGrid.forEach((swiper) => {
				swiper.destroy(true, true);
			});
		} else {
			swiperCollectionGrid.destroy(true, true);
		}
		swiperCollectionGrid = null;

		slides.forEach((slide) => {
			slide.removeAttribute("style");
			slide.classList.remove("swiper-slide");
		});
	};

	const initMulticolumn = () => {
		const multicolumnSection = document.querySelector(".collection-grid-section");

		const sectionResizeObserver = new ResizeObserver((entries) => {
			const [entry] = entries;

			if (entry.contentRect.width < 991 && collectionGridSwipeEnabled) {
				addClasses();
				initSlider();
			} else if (swiperCollectionGrid) {
				destroySlider();
			}
		});

		sectionResizeObserver.observe(multicolumnSection);
	};

	if (swiperCollectionGrid) {
		destroySlider();
	}
	addClasses();
	initMulticolumn();
	initSlider();
	document.addEventListener("shopify:section:load", function () {
		if (swiperCollectionGrid) {
			destroySlider();
		}
		addClasses();
		initMulticolumn();
		initSlider();
	});
})();
